import getFullImageUrl from './getFullImageUrl';
import { URLS } from './constants';

function getImageMenuSection({ image, width, height, country }) {
  if (!image || !country) return '';

  return getFullImageUrl({
    url: `${URLS.MENU_SECTION}${country}/`,
    image,
    width,
    height,
  });
}

export default getImageMenuSection;
